
/***************************** Module ************************************/


import { name as storage } from "@modules/storage/storage.module";

import { module_name as userData } from "@modules/user/user-data.module"


/************************************** Service ***********************************************/

import { name as accessor } from "@modules/accessor/accessor.module";
import { ProductCatalogRestService } from '@modules/catalog/product-catalog/rest/product-catalog-rest.service';
import type { RestfulAccessorProvider } from '@core/data-access/restful';
import { ProductCatalogRestServiceConfig } from '@modules/catalog/product-catalog/rest/product-catalog-rest.config';
import { HeaderController } from "./header.controller";
import { HeaderObjectTreeService } from "./header-object-tree.service";
import { CartRestService } from "@modules/cart/rest/cart-rest-service";
import { PartnerCartRestServiceConfig } from "@modules/cart/rest/partner-cart-rest-service.config";
import { UserCartRestServiceConfig } from "@modules/cart/rest/user-cart-rest-service.config";
import { CartRestServicesV2Provider } from "@modules/cart/rest/cart-rest-service-v2.provider";
import { AnonymousPagePermissionService } from "@modules/basic/page/anonymous/anonymous-page.service";
import { CurrencyRestService } from "@modules/partner/rest/currency/currency-rest.service";
import { UrlBuilder } from "@modules/common/rest/service/url-builder.service";
import { PageNameFilter } from "@filters/page-name-filter";
import { QpMenuDirective } from "@directives/qp-menu/qp-menu.directive";
import { QpMenuItemDirective } from "@directives/qp-menu/qp-menu-item.directive";
import { QpMenuChildDirective } from "@directives/qp-menu/qp-menu-child.directive";
import type { IPermissionService } from "@modules/basic/page/page-service";
import { preferenceEditorRegister } from "@components/preference-editor/preference-editor-component.register"
import { UserDataService } from "@modules/user/service/data/user-data-service";
import { IUserData } from "@modules/user/rest/data/user-data-proxy";
import { PageObjectTreeService } from "@modules/basic/page/page-object-tree.service";

/************************************** 内容注册 ***********************************************/


let PageModule_name = "qpmn-header"
const headerModule = angular.module(PageModule_name, [accessor, userData])
    .directive({
        qpMenu: QpMenuDirective,
        qpMenuItem: QpMenuItemDirective,
        qpMenuChild: QpMenuChildDirective
    })
    .controller({
        headerController: HeaderController,
    })
    .service({
        headerObjectTree: HeaderObjectTreeService,
        productCatalogRestService: ProductCatalogRestService,
        cartRestService: CartRestService,
        urlBuilder: UrlBuilder,
        currencyRestService: CurrencyRestService,
    })
    .config(["$accessorProvider", function ($accessorProvider: RestfulAccessorProvider) {
        $accessorProvider.config(ProductCatalogRestServiceConfig);
        $accessorProvider.config(PartnerCartRestServiceConfig);
        $accessorProvider.config(UserCartRestServiceConfig);
    }])
    .provider({
        cartRestService: CartRestServicesV2Provider,
    })

    .service({
        permissionService: AnonymousPagePermissionService,
    })

    .run(["permissionService", "$templateCache", "userDataService", "$objectTree",
        function (
            permissionService: IPermissionService,
            $templateCache: angular.ITemplateCacheService,
            userDataService: UserDataService,
            $objectTree: PageObjectTreeService,
        ) {
        // Token有效期检验
        permissionService.syncCheckAuthorization(function() {
            userDataService.getUserDataWithoutCache().then(res => {
                let userPreferences: IUserData = res;
    
                $objectTree.setCurrentPreference(userPreferences);
            });
        });
    }])
    .filter({
        pageNameFilter: PageNameFilter
    })

preferenceEditorRegister.regist(headerModule);
export { PageModule_name }